import React, { ComponentType } from 'react';
import errorBoundary from 'presentation/hocs/errorBoundary';
import visibilitySet from 'presentation/hocs/visibilitySet';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';
import { Container } from '@uds/grid';
import { IconName } from '@uds/glyphs';
import { Heading04 } from '@uds/typography';
import { useTheme } from '@uds/theme-utils';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import { isNotNilNorEmpty } from 'presentation/utils/generalUtils';

import DomainSearchForm from '../domain-search-start/DomainSearchForm';
import useStylesheet, { getClassNames } from './DomainSearchStartStrip.stylesheet';
import Ribbon from '../Ribbon';

export interface OuterProps extends RibbonProps {
  text: {
    title?: ShortcodeProps;
  };
  search: {
    tld: string;
    glyph: IconName;
    label: string;
    placeholder?: string;
    destination?: string;
  };
}

const DomainSearchStartStrip = ({ id, loading, colorway, layout, hBaseline, name, text, search }: OuterProps) => {
  const { title } = text;
  const { theme } = useTheme();
  const { styles } = useStylesheet({
    theme,
  });
  const hasTitle = isNotNilNorEmpty(title);
  const classNames = getClassNames();
  return (
    <Ribbon
      id={id}
      name={name}
      layout={layout}
      colorway={colorway}
      loading={loading}
      flush={true}
      type={Type.DOMAIN_SEARCH_START_STRIP}
    >
      <Container>
        <div style={styles.content}>
          {hasTitle && (
            <Heading04 depth={hBaseline} className={classNames.title}>
              <Shortcode against={colorway} code={title} />
            </Heading04>
          )}
          <div style={styles.search}>
            <DomainSearchForm search={search} ribbonName={'domainSearchStartStrip'} isStrip={true} id={id} />
          </div>
        </div>
      </Container>
    </Ribbon>
  );
};

export default errorBoundary(visibilitySet(DomainSearchStartStrip)) as ComponentType<OuterProps>;
